import { useId, useState } from 'react';
import type { ReactNode } from 'react';

export type ListSectionProps = {
  /** Rendered as the section's `h3`. */
  title: string;
  /** Number of items in the section, shown next to the title. */
  count: number;
  /** Short figure aligned to the end of the header, typically a total amount. */
  summary?: ReactNode;
  /** Lets the user fold the section from its header. A section that is not collapsible is always expanded. */
  collapsible?: boolean;
  /** Initial state of a collapsible section. @default true */
  defaultExpanded?: boolean;
  children?: ReactNode;
  'data-testid'?: string;
};

export function useListSection(props: ListSectionProps) {
  const contentId = useId();
  const [isExpandedState, setIsExpandedState] = useState(props.defaultExpanded ?? true);
  const isExpanded = !props.collapsible || isExpandedState;

  function handleToggle() {
    setIsExpandedState((previous) => !previous);
  }

  return {
    contentId,
    isExpanded,
    handleToggle,
  };
}
